export default {
      id: "ic_recherche-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_recherche-usage",
      toString: function () {
        return this.url;
      }
    }